import React from 'react'
import { Checkbox, makeStyles } from '@zn-material-ui'

export default function Checkoutagreement(props: any) {
  const classes = useStyles()
  const [checked, setChecked] = React.useState(true)
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkedStatus = event.target.checked
    setChecked(checkedStatus)
    props.setChecked(checkedStatus)
  }
  return (
    <div>
      <Checkbox
        color="primary"
        onChange={handleChange}
        inputProps={{ 'aria-label': 'primary checkbox' }}
        className={classes.root}
        size="small"
      />
    </div>
  )
}
const useStyles = makeStyles({
  root: {
    padding: 0,
    position: 'absolute',
    width: 20,
    height: 20,
    left: -1,
    top: -2,
  },
})
